import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const FIREBASE_PUSH_SCOPE = "firebase-cloud-messaging-push-scope";

const getFirebaseApp = (app = {}) => {
    if (!app.appId) {
        throw new Error("appId must be set");
    }
    if (!app.apiKey) {
        throw new Error("apiKey must be set");
    }
    if (!app.projectId) {
        throw new Error("projectId d must be set");
    }
    if (!app.senderId) {
        throw new Error("senderId must be set");
    }

    /*
     * Give the service worker access to Firebase Messaging.
     * Note that you can only use Firebase Messaging here. Other Firebase libraries
     * are not available in the service worker.
     * Initialize the Firebase app in the service worker by passing in
     * your app's Firebase config object.
     * https://firebase.google.com/docs/web/setup#config-object
     */
    return initializeApp({
        messagingSenderId: app.senderId,
        projectId: app.projectId,
        apiKey: app.apiKey,
        appId: app.appId
    });
};

const getFCMMessaging = (app = {}) => {
    return getMessaging(getFirebaseApp(app));
};

const getFCMToken = async (messaging, params = {}) => {
    if (!messaging) {
        throw new Error("Invalid instance of FCM messaging");
    }
    return getToken(messaging, params);
};

const isNotificationAvailable = () => {
    return "Notification" in window;
};

const isPermissionGranted = () => {
    return Notification.permission === "granted";
};

const isPermissionDenied = () => {
    return Notification.permission === "denied";
};

export {
    FIREBASE_PUSH_SCOPE,
    isNotificationAvailable,
    isPermissionGranted,
    isPermissionDenied,
    getFCMMessaging,
    getFCMToken
};
